import { render, staticRenderFns } from "./OfficeHour.vue?vue&type=template&id=0d25764e"
import script from "./OfficeHour.vue?vue&type=script&lang=js"
export * from "./OfficeHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports